import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactTable from "../../AppComponent/Table";
import _ from "lodash";
import DeleteImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-05.svg";

import {
    GetSheetBulkUploadDataRequest,
    GetSheetBulkUploadDataSucess,
    SheetBulkUploadSucess,
} from "../../../Redux/Slice";
import { FaDownload } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const DenaveBulkuploadNewPreview = () => {
    const stateDisplay = useSelector(
        (state) => state.SideBarActive.SidebarActive,
    );
    const dispatch = useDispatch();
    const [sno, setsno] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);

    const [dtpageindex, setdtPageindex] = useState(1);
    const [dtpagesize, setdtPagesize] = useState(10);
    const [search, setsearch] = useState("");
    const [DeleteID, setDeleteId] = useState();
    const [DeletePopup, setDeletePopup] = useState(false);
    const [pageSize, setPageSize] = useState(20);

    const { sheetBulkUploaddata, totalCount } = useSelector(
        (state) => state.sheetBulkUploadGetData,
    );
    const [bulkUploadPopup, setBulkUploadPopup] = useState(false);
    const navigate = useNavigate();
    const pagesize = (arg) => {
        setdtPagesize(arg);
    };
    const pageindex = (arg) => {
        //  console.log(arg, "args");
        setdtPageindex(arg);
    };

    const debouncedSearch = useMemo(
        () =>
            _.debounce((e) => {
                // console.log("Searching for:", e);

                setsearch(e);
            }, 500),
        [],
    );
    function tochange(e) {
        setdtPageindex(1);
        // setsearch(e);
        debouncedSearch(e);
    }

    const handleNext = (next) => {
        setdtPageindex(next + 1);
    };

    const GotoEnteredPage = (gotopage) => {
        setdtPageindex(gotopage);
    };

    const handleDownload = (url) => {
        if (!url) return;

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    useEffect(() => {
        const payload = {
            page_size: 20,
            page: 1,
            search: "",
            report_type: "3",
        };
        dispatch(GetSheetBulkUploadDataRequest(payload));
    }, []);
    useEffect(() => {
        const payload = {
            page_size: 20,
            page: dtpageindex,
            search: "",
            report_type: "3",
        };
        dispatch(GetSheetBulkUploadDataRequest(payload));
    }, [dtpageindex]);
    useEffect(() => {
        if (!sheetBulkUploaddata || sheetBulkUploaddata.length === 0) return;

        const hasPending = sheetBulkUploaddata.some((item) => item.status === "0");

        if (!hasPending) return;

        const interval = setInterval(() => {
            dispatch(
                GetSheetBulkUploadDataRequest({
                    page_size: 20,
                    page: dtpageindex,
                    search: "",
                    report_type: "3",
                }),
            );
        }, 15000);

        return () => clearInterval(interval);
    }, [sheetBulkUploaddata]);
    const handlePrevious = (previous) => {
        if (previous != 0) {
            setdtPageindex(previous);
        }
    };

    const columns = useMemo(
        () => [
            {
                Header: "S.NO",
                accessor: "",
                Cell: (row) => {
                    console.log(row.row);
                    console.log(sno);
                    return <p>{Number(sno + row.row.index + 1)}</p>;
                },
            },
            {
                Header: "Created Date",
                accessor: "",
                Cell: (row) => {
                    const dateString = row.row.original.created_at;
                    const dateObject = new Date(dateString);
                    const hours = dateObject.getHours();
                    const minutes = dateObject.getMinutes();
                    const seconds = dateObject.getSeconds();
                    const amOrPm = hours >= 12 ? "PM" : "AM";
                    const twelveHourFormat = hours % 12 || 12;
                    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

                    const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;
                    return (
                        <>
                            <span>
                                {`${row.row.original.created_at.slice(0, 10) +
                                    "  " +
                                    formattedTime
                                    }`}
                            </span>
                        </>
                    );
                },
            },
            {
                Header: "File Name",
                accessor: "file_name",
                Cell: (row) => {
                    const FileName = row.row.original?.file_name;
                    return (
                        <>
                            <span
                                style={{
                                    width: "160px",
                                    display: "inline-block",
                                    wordBreak: "break-word",
                                    overflowWrap: "break-word",
                                    textWrap: "wrap",
                                }}
                            >
                                {FileName}
                            </span>
                        </>
                    );
                },
            },
            {
                Header: "Report Type",
                accessor: "report_type",
                Cell: (row) => {
                    const ReportType = row.row.original?.report_type;
                    return (
                        <>
                            <span>
                                {ReportType == "0"
                                    ? "Client"
                                    : ReportType == "1"
                                        ? "Existing Employee"
                                        : "Denave Employee"}
                            </span>
                        </>
                    );
                },
            },
            {
                Header: "Total Count",
                accessor: "total_count",
                Cell: (row) => {
                    const TotalCount = row.row.original?.total_count;
                    return (
                        <>
                            <span>{TotalCount}</span>
                        </>
                    );
                },
            },
            {
                Header: "Sucess Count",
                accessor: "valid_count",
                Cell: (row) => {
                    const sucess = row.row.original?.valid_count;
                    return (
                        <>
                            <span>{sucess}</span>
                        </>
                    );
                },
            },
            {
                Header: "Defect Count",
                accessor: "defect_count",
                Cell: (row) => {
                    const Count = row.row.original?.defect_count;
                    return (
                        <>
                            <span>{Count}</span>
                        </>
                    );
                },
            },

            {
                Header: "Uploaded Sheet",
                accessor: "",
                Cell: (row) => {
                    const url = row.row.original?.uploaded_sheet;

                    return url ? (
                        <span
                            style={{ cursor: "pointer" }}
                            onClick={() => handleDownload(url)}
                            title="Download Uploaded Sheet"
                        >
                            <FaDownload size={18} />
                        </span>
                    ) : null;
                },
            },
            {
                Header: "Defect Sheet",
                accessor: "defect_sheet",
                Cell: (row) => {
                    const url = row.row.original?.defect_sheet;

                    return url ? (
                        <span
                            style={{ cursor: "pointer" }}
                            onClick={() => handleDownload(url)}
                            title="Download Defect Sheet"
                        >
                            <FaDownload size={18} />
                        </span>
                    ) : (
                        "-"
                    );
                },
            },
            {
                Header: "Process",
                accessor: "upload_status",

                Cell: (row) => {
                    return (
                        <>
                            <span>
                                {Math.round(Number(row.row.original?.upload_status || 0))}%
                            </span>
                        </>
                    );
                },
            },
            {
                Header: "Status",
                accessor: "status",

                Cell: (row) => {
                    const status = row.row.original?.status;
                    return (
                        <>
                            <span>
                                {status == "0"
                                    ? "Pending"
                                    : status == "1"
                                        ? "Completed"
                                        : "Failed"}
                            </span>
                        </>
                    );
                },
            },
        ],

        [sheetBulkUploaddata],
    );

    const sampleData = [
        {
            id: 1,
            name: "Pradap",
            email: "pradap@test.com",
            role: "Admin",
            status: "Active",
        },
        {
            id: 2,
            name: "Arun",
            email: "arun@test.com",
            role: "User",
            status: "Inactive",
        },
        {
            id: 3,
            name: "Karthik",
            email: "karthik@test.com",
            role: "Manager",
            status: "Active",
        },
        {
            id: 4,
            name: "Divya",
            email: "divya@test.com",
            role: "User",
            status: "Active",
        },
        {
            id: 5,
            name: "Sneha",
            email: "sneha@test.com",
            role: "HR",
            status: "Inactive",
        },
    ];

    //   const columns = useMemo(
    //     () =>
    //       [
    //         {
    //           Header: "S.NO",
    //           accessor: "",
    //           Cell: (row) => {
    //             console.log(row.row);
    //             console.log(sno);
    //             return <p>{Number(sno + row.row.index + 1)}</p>;
    //           },
    //         },
    //         {
    //           Header: "Name",
    //           accessor: "name",
    //           Cell: (row) => {
    //             return <p>{row.row.original.name}</p>;
    //           },
    //         },
    //         {
    //           Header: "Actions",
    //           accessor: "",
    //           Cell: (row) => {
    //             return (
    //               <>
    //                 <div
    //                   class="actions"
    //                   style={{
    //                     display: "flex",
    //                     justifyContent: "flex-start",
    //                     gap: "5px",
    //                   }}
    //                 >
    //                   <button
    //                     type="button"
    //                     class="btn Status"
    //                     onClick={(e) => {
    //                       e.stopPropagation();
    //                       setsearch("");
    //                       setDeleteId(row.row.original.id);
    //                       setDeletePopup(true);
    //                     }}
    //                   >
    //                     <span className="OuterActionSpan">
    //                       <span className="EditImages">
    //                         <img src={DeleteImages} />
    //                       </span>

    //                       <span className="ActionsList"> Delete </span>
    //                     </span>
    //                   </button>
    //                 </div>
    //               </>
    //             );
    //           },
    //         },
    //       ][(sno, sampleData)],
    //   );

    return (
        <>
            <div className={stateDisplay ? "outterContent" : "inner-Content"}>
                <div
                    className="Header-Details ClientBranch"
                    style={{
                        padding: "14px 28px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "20px !important",
                    }}
                >
                    <div
                        // className="InnerUsers col-md-6"
                        class="col-sm-7 auto"
                        style={{
                            display: "flex",
                            alignItems: "flex-start",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        <h3 class="user-name mb-0">Self Onboard Bulkupload Status </h3>
                    </div>
                    <div className="Add-User col-sm-5">
                        <button
                            onClick={(e) => {
                                navigate("/denavebulkupload");
                            }}
                            className="ButtonCSS"
                            style={{ marginBottom: "10px" }}
                        >
                            Back
                        </button>
                    </div>
                </div>
                <div
                    style={{
                        padding: " 0px 40px",
                        marginTop: "-13px",
                        marginBottom: "20px",
                    }}
                >
                    <ReactTable
                        data={sheetBulkUploaddata ? sheetBulkUploaddata : []}
                        columns={columns}
                        // totalItems={state.ReportSheetData.Total_Count}
                        currentPage={currentPage}
                        onChange={tochange}
                        setCurrentPage={setCurrentPage}
                        pagesize={pagesize}
                        dtpagesize={pageSize}
                        dtpageindex={dtpageindex}
                        pageindex={pageindex}
                        // datacount={state.ReportSheetData.Total_Count}
                        // datacount={state.ReportSheetData?.Total_Count}
                        totalItems={totalCount}
                        datacount={totalCount}
                        MakeCreate={false}
                        ///--- emoloyee role based filters -
                        // Filter={true}
                        // EmployeeRoleTrue={false}
                        // EmployeeRoleOption={EmpRoles}
                        // EMpROleSelected={EMpROleSelected}
                        // HandleEMprole={HandleEMprole}
                        //---status
                        onPrevious={handlePrevious}
                        onNextpage={handleNext}
                        GotoEnteredPage={GotoEnteredPage}
                        // value={StatusVal}
                        // options={options}
                        // count={count}
                        // ClearState={ClearState}
                        placeHold={"All"}
                        setsno={setsno}
                        sno={sno}
                        id={"spe"}
                        ApproveRequestFilter={true}
                        search_key={true}
                    />
                </div>
            </div>
        </>
    );
};


export default DenaveBulkuploadNewPreview